import React from "react";
import { useAuth } from "../../../usercontext";
import GlobalBragSheet from "../../pages/common/globalbragsheet";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";
import PageNotes from '../../pages/common/pagenotesnew'

export default function StudentBragSheet() {
	const { profile } = useAuth()
	const slug = profile.id
	const isStudent12 = profile?.role === 'Student12'
	const isStudent = profile?.role === 'Student'
	return (
		<>
			{isStudent && <STopMenu slug={slug} activeMenu="BragSheet" />}
			{isStudent12 && <S12TopMenu slug={slug} activeMenu="BragSheet" />}
			<PageNotes type={'Student'} studentId={slug} />
			<div className="col-12">
				<div className="settings-widget">
					<GlobalBragSheet slug={slug} />
				</div>
			</div>
		</>
	)
}
